import { render, staticRenderFns } from "./remark_temp_selector.vue?vue&type=template&id=0fb53364&"
import script from "./remark_temp_selector.vue?vue&type=script&lang=js&"
export * from "./remark_temp_selector.vue?vue&type=script&lang=js&"
import style0 from "./remark_temp_selector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports